import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addAisVesselToFleet,
  createMysteryShip,
  deleteMysteryShip,
  fetchAisVesselList,
  fetchMysteryShipList,
  updateMysteryShip,
} from "../../apis/aisVessels";

import type { MysteryShip } from "../../utils/types/aisVessels";

export const fetchAisVessels = createAsyncThunk(
  "aisVessels/fetchAisVessels",
  async (_, { rejectWithValue }) => {
    try {
      const result = await fetchAisVesselList();
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState() as any;
      return !state.aisVessels.isDataFetched;
    },
  }
);

export const addAisVesselToFleetThunk = createAsyncThunk(
  "aisVessels/addToFleet",
  async ({ aisVesselId }: { aisVesselId: string }, { rejectWithValue }) => {
    try {
      await addAisVesselToFleet(aisVesselId);
      return aisVesselId;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchMysteryShips = createAsyncThunk(
  "aisVessels/fetchMysteryShips",
  async (_, { rejectWithValue }) => {
    try {
      const result = await fetchMysteryShipList();
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState() as any;
      return !state.aisVessels.mysteryShipsFetched;
    },
  }
);

export const createMysteryShipThunk = createAsyncThunk(
  "aisVessels/createMysteryShip",
  async (
    {
      data,
    }: {
      data: Omit<MysteryShip, "mystery_ship_id" | "created_dt" | "created_by">;
    },
    { rejectWithValue }
  ) => {
    try {
      const result = await createMysteryShip(data);
      return result.data ?? result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteMysteryShipThunk = createAsyncThunk(
  "aisVessels/deleteMysteryShip",
  async ({ mysteryShipId }: { mysteryShipId: string }, { rejectWithValue }) => {
    try {
      await deleteMysteryShip(mysteryShipId);
      return mysteryShipId;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateMysteryShipThunk = createAsyncThunk(
  "aisVessels/updateMysteryShip",
  async (
    {
      mysteryShipId,
      data,
    }: {
      mysteryShipId: string;
      data: Partial<MysteryShip>;
    },
    { rejectWithValue }
  ) => {
    try {
      const result = await updateMysteryShip(mysteryShipId, data);
      return result.data ?? result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
